import { useAuth } from "@/context/AuthContext";
import { ChatThread } from "@/components/ChatThread";

export default function TenantMessages() {
  const { user } = useAuth();
  return (
    <div>
      <h1 className="text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-900 mb-1">Messages</h1>
      <p className="text-sm text-slate-500 mb-6">Chat directly with your landlord. Rent notices you receive also appear here.</p>
      <div className="rounded-2xl border border-slate-200 bg-white overflow-hidden flex flex-col h-[calc(100vh-240px)] min-h-[480px]" data-testid="tenant-messages">
        <ChatThread tenantId={user.id} myRole="tenant" />
      </div>
    </div>
  );
}
